import React from 'react';
import './style.scss';

const Loading = ({ loading, className, style }) => {
  // if (!loading) {
  //   return null;
  // }

  return (
    <div className={`loading ${className}`} style={style}>
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default React.memo(Loading);
